import React from "react"
import axios from "axios";
import { Icon } from 'antd';
import { setup as URI_SETUP } from "../../../../config/api";

const uri_users = URI_SETUP+"userrole";
const uri_modules = URI_SETUP+"contracted_module";
const uri_modules_hotel = URI_SETUP+"contracted_module_hotel";
class AddUser extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title                 : "NEW USER",
            hotels                : [],
            modules               : [],
            selected_modules      : [],
            min_selected_modules  : [],
            user    :{
                        _id: "",
                        name: "",
                        lastname: "",
                        birthdate: "",
                        position: "",
                        email: "",
                        phone: "",
                        role: ""
                    },
            user_action           : "new",
            hotel_selected_status : "hide",
            hotel_checked_status  : "hide",
            selected_hotel        : "",
            selected_hotel_name   : "",
            fireExistError        : false,
            fireRequiredError     : false,
            loaded                : "hide",
            show_loading          : ""
        }
    }

    componentWillMount(){
        this.checkUser();
    }

    checkUser(){
        if (this.props.editing_user != ""){
            this.setState({
                user_action : "edit",
                title : "EDIT USER"
            })
            this.getUser();
        }else{
            this.setState({
                user_action : "new",
                loaded: "show",
                show_loading : "hide",
                title : "NEW USER"
            })
        }
    }

    handleUserChange = (e) => {
        let user = Object.assign({}, this.state.user);
        user[e.target.name] = e.target.value;
        this.setState({user});
    }

    handleHotelChange = (e) => {
        if( e.target.value != ""){
            this.state.selected_hotel = e.target.value;
            let index = e.target.selectedIndex;
            this.getModulesByHotel(this.state.selected_hotel, e.target[index].text);
            this.setState({
                hotel_selected_status : "show",
                selected_hotel_name: e.target[index].text
            });
            this.renderModulesPanles();
        }else{
            this.setState({hotel_selected_status : "hide"});
        }
    }

    handleModuleChange = (e, module_id) => {
        let self = this;
        let panel_id = e.target.value;

        Object.keys(self.state.selected_modules).map((key, index) => {
            if(self.state.selected_modules[key].hotel_id == self.state.selected_hotel){
                Object.keys(self.state.selected_modules[key].modules).map((keymod, index) => {
                    if(self.state.selected_modules[key].modules[keymod].id == module_id){
                        Object.keys(self.state.selected_modules[key].modules[keymod].panels).map((keypanels, index) => {
                            if(self.state.selected_modules[key].modules[keymod].panels[keypanels]._id == panel_id){
                                self.state.selected_modules[key].modules[keymod].panels[keypanels].selected = e.target.checked;
                            }
                        })
                    }
                })
            }
        })

        self.refreshModules();
        self.renderSelectedModulesPanles();
    }

    refreshModules(){
        let self = this;
        var show_selected = "hide";
        Object.keys(self.state.selected_modules).map((key, index) => {
            var hotel_selected = false;
                Object.keys(self.state.selected_modules[key].modules).map((keymod, index) => {
                    var module_selected = false;
                        Object.keys(self.state.selected_modules[key].modules[keymod].panels).map((keypanels, index) => {
                            if(self.state.selected_modules[key].modules[keymod].panels[keypanels].selected == true){
                                module_selected = true;
                                hotel_selected = true;
                                show_selected = "show";
                            }
                        })
                    self.state.selected_modules[key].modules[keymod].selected = module_selected;
                })
            self.state.selected_modules[key].selected = hotel_selected;
        })

        self.setState({
            hotel_checked_status : show_selected
        })

        self.setSelectedModules();
    }

    setSelectedModules(){
        let self = this;
        var array_full_modules = [];
        Object.keys(self.state.selected_modules).map((key, index) => {
            var array_hotel = [];
            if(self.state.selected_modules[key].selected){
                array_hotel = ({
                    hotel_id: self.state.selected_modules[key].hotel_id,
                    hotel_name: self.state.selected_modules[key].hotel_name
                });
                var array_modules = [];
                Object.keys(self.state.selected_modules[key].modules).map((keymod, index) => {
                    var array_module = [];
                    if(self.state.selected_modules[key].modules[keymod].selected){
                        array_module = ({
                            id: self.state.selected_modules[key].modules[keymod].id,
                            name: self.state.selected_modules[key].modules[keymod].name,
                            icon: self.state.selected_modules[key].modules[keymod].icon,
                            color: self.state.selected_modules[key].modules[keymod].color,
                            short_name: self.state.selected_modules[key].modules[keymod].short_name
                        });
                        var array_panels = [];
                        Object.keys(self.state.selected_modules[key].modules[keymod].panels).map((keypanels, index) => {
                            var array_panel = [];
                            if(self.state.selected_modules[key].modules[keymod].panels[keypanels].selected == true){
                                array_panel = ({
                                    id: self.state.selected_modules[key].modules[keymod].panels[keypanels]._id,
                                    name: self.state.selected_modules[key].modules[keymod].panels[keypanels].name,
                                    value: self.state.selected_modules[key].modules[keymod].panels[keypanels].value,
                                    icon: self.state.selected_modules[key].modules[keymod].panels[keypanels].icon,
                                    color: self.state.selected_modules[key].modules[keymod].panels[keypanels].color,
                                    short_name: self.state.selected_modules[key].modules[keymod].panels[keypanels].short_name,
                                    dashboards: self.state.selected_modules[key].modules[keymod].panels[keypanels].dashboards
                                });
                                array_panels.push(array_panel);
                            }
                        })
                        array_module.panels = array_panels;
                        array_modules.push(array_module);
                    }
                })
                array_hotel.modules = array_modules;
                array_full_modules.push(array_hotel);
            }
        })

        console.log(array_full_modules);
        self.setState({
            min_selected_modules: array_full_modules
        });
    }
    
    // Get Contracted modules
    getUser(){
        let self = this;
        var qs = require("qs");

        const userToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token"),
            user_id     : self.props.editing_user
        });
        axios.post(uri_users+"/getUser", userToSent)
                .then(request => { 
                    if(request.data["status"]== "success"){
                        var user = [];
                        var modules = [];
                        user._id     =  request.data.data._id;
                        user.name    =   request.data.data.name;
                        user.lastname=  request.data.data.lastname;
                        user.birthdate= request.data.data.birthdate;
                        user.position=  request.data.data.position;
                        user.email  =   request.data.data.email;
                        user.phone  =   request.data.data.phone;
                        user.role   =   request.data.data.sys_roll_id;
                        modules     =   request.data.data.modules;

                        self.setState({
                            user: user,
                            min_selected_modules: modules,
                            loaded: "show",
                            show_loading : "hide"
                        })

                        self.setSelectedModulesOnEdit();
                    }
                })
    }

    setSelectedModulesOnEdit(){
        let self = this;
        if(self.state.min_selected_modules!= null){
            Object.keys(self.state.min_selected_modules).map((key, index) => {
                self.getModulesByHotel(self.state.min_selected_modules[key].hotel_id, self.state.min_selected_modules[key].hotel_name);
            })
            self.setState({
                hotel_checked_status: "show"
            })
            self.renderSelectedModulesPanles();
        } else{
            self.setState({
                min_selected_modules : []
            })
        }
    }

    getModulesByHotel(hotel_id, hotel_name){
        let self = this;
        var exist = false;
        Object.keys(self.state.selected_modules).map((key, index) => {
            if(self.state.selected_modules[key].hotel_id == hotel_id){
                exist = true;
                self.state.selected_modules[key].visible = "show";
                self.setState({ 
                    modules : self.state.selected_modules[key].modules
                }) 
            }else{
                self.state.selected_modules[key].visible = "hide";
            }
        })
        if (exist == false){
            var qs = require("qs");
            const userToSent = qs.stringify({
                api_token   : localStorage.getItem("api_token"),
                business_id : self.props.business_id,
                hotel_id : hotel_id,
            });
            axios.post(uri_modules_hotel, userToSent)
                    .then(request => { 
                        self.setState({
                            modules : request.data
                        })
                        this.initializeSelectedModules(hotel_id, hotel_name);
                    })
        }
    }

    initializeSelectedModules(hotel_id, hotel_name){
        let self = this;
        let selected_modules = self.state.selected_modules;
        var hotel_selected = false;

        Object.keys(self.state.min_selected_modules).map((keyhot, index) => {
            if(self.state.min_selected_modules[keyhot].hotel_id == hotel_id){
                hotel_selected = true;
            }
        })
        var hotel_modules = ({
            hotel_id : hotel_id, 
            hotel_name : hotel_name,
            visible: "show", 
            selected: hotel_selected, 
            modules : self.state.modules 
        });

        Object.keys(hotel_modules.modules).map((key, index) => {
            var mod_selected = false;
            Object.keys(self.state.min_selected_modules).map((keyhot, index) => {
                if(self.state.min_selected_modules[keyhot].hotel_id == hotel_id){
                    Object.keys(self.state.min_selected_modules[keyhot].modules).map((keymod, index) => {
                        if(self.state.min_selected_modules[keyhot].modules[keymod].id == hotel_modules.modules[key].id) {
                            mod_selected = true;
                        }
                    })
                }
            })
            hotel_modules.modules[key].selected = mod_selected;

            Object.keys(hotel_modules.modules[key].panels).map((keypanels, index) => {
                var panel_selected = false;
                Object.keys(self.state.min_selected_modules).map((keyhot, index) => {
                    if(self.state.min_selected_modules[keyhot].hotel_id == hotel_id){
                        Object.keys(self.state.min_selected_modules[keyhot].modules).map((keymod, index) => {
                            if(self.state.min_selected_modules[keyhot].modules[keymod].id == hotel_modules.modules[key].id) {
                                Object.keys(self.state.min_selected_modules[keyhot].modules[keymod].panels).map((keypan, index) => {
                                    if(self.state.min_selected_modules[keyhot].modules[keymod].panels[keypan].id == hotel_modules.modules[key].panels[keypanels]._id) {
                                        panel_selected = true;
                                    }
                                })
                            }
                        })
                    }
                })
                hotel_modules.modules[key].panels[keypanels].selected = panel_selected;
            })
        })
        selected_modules.push(hotel_modules);

        self.setState({
            selected_modules : selected_modules,
            modules : hotel_modules.modules
        })
    }
    
    // Render 
    renderHotels(){
        let self = this;
        return  Object.keys(self.props.hotels).map((key, index) => {
            return (<option key={self.props.hotels[key]._id} value={self.props.hotels[key]._id}>{self.props.hotels[key].name}</option>);
            })
    }

    renderRoles(){
        let self = this;
        return  Object.keys(self.props.roles).map((key, index) => {
            return (<option key={self.props.roles[key]._id} value={self.props.roles[key]._id} >{self.props.roles[key].name}</option>);
            })
    }

    renderModulesPanles(){
        return Object.keys(this.state.selected_modules).map((keyhotels, index) => {
            return  (<div className={"modules "+ this.state.selected_modules[keyhotels].visible} key={this.state.selected_modules[keyhotels].hotel_id}>
            {Object.keys(this.state.selected_modules[keyhotels].modules).map((key, index) => {
                return (<div className="icons-revenue" key={this.state.selected_modules[keyhotels].modules[key].id}>
                            <span className={"icon-module " + this.state.selected_modules[keyhotels].modules[key].icon } style={{ backgroundColor: '#'+this.state.selected_modules[keyhotels].modules[key].color }}></span>
                            <span className="module-name"> {this.state.selected_modules[keyhotels].modules[key].name} </span>
                            {Object.keys(this.state.selected_modules[keyhotels].modules[key].panels).map((keypanel, index) => {
                                return (<div className="hotel-checkbox" key={this.state.selected_modules[keyhotels].modules[key].panels[keypanel]._id}>
                                    <div className="checkbox">
                                        <label className="container-check"> {this.state.selected_modules[keyhotels].modules[key].panels[keypanel].name}
                                            <input 
                                            type="checkbox" 
                                            name={this.state.selected_hotel+ '-' +this.state.selected_modules[keyhotels].modules[key].id + '-' + this.state.selected_modules[keyhotels].modules[key].panels[keypanel]._id} 
                                            value={this.state.selected_modules[keyhotels].modules[key].panels[keypanel]._id} 
                                            onChange={e => this.handleModuleChange(e, this.state.selected_modules[keyhotels].modules[key].id)} 
                                            defaultChecked={this.state.selected_modules[keyhotels].modules[key].panels[keypanel].selected} />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                                );
                            })
                            }
                        </div>
                    );
                })
            }
            </div>);
        })
    }

    renderSelectedModulesPanles(){
        return Object.keys(this.state.selected_modules).map((keyhotels, index) => {
            if(this.state.selected_modules[keyhotels].selected){
                var str = this.state.selected_modules[keyhotels].hotel_name;
                var matches = str.match(/\b(\w)/g); 
                var acronym = matches.join(''); 

                return  (<div className={"selected-hotels modules"} key={this.state.selected_modules[keyhotels].hotel_id}>
                <span className="icon-module icon-hotel">{acronym}</span>
                <span className="hotel">{this.state.selected_modules[keyhotels].hotel_name}</span>
                {Object.keys(this.state.selected_modules[keyhotels].modules).map((key, index) => {
                    if(this.state.selected_modules[keyhotels].modules[key].selected){
                        return (<div className="selected-modules" key={this.state.selected_modules[keyhotels].modules[key].id}>
                                <span className={"icon-module " + this.state.selected_modules[keyhotels].modules[key].icon } style={{ backgroundColor: '#'+this.state.selected_modules[keyhotels].modules[key].color }}></span>
                                <span className="module-name"> {this.state.selected_modules[keyhotels].modules[key].name} </span>
                                {Object.keys(this.state.selected_modules[keyhotels].modules[key].panels).map((keypanel, index) => {
                                    if(this.state.selected_modules[keyhotels].modules[key].panels[keypanel].selected){
                                        return (<div className="selected-panels" key={this.state.selected_modules[keyhotels].modules[key].panels[keypanel]._id}>
                                            <span className={"icon-module " + this.state.selected_modules[keyhotels].modules[key].panels[keypanel].icon } style={{ backgroundColor: '#'+this.state.selected_modules[keyhotels].modules[key].panels[keypanel].color }}></span>
                                            <span className="module-name"> {this.state.selected_modules[keyhotels].modules[key].panels[keypanel].name} </span>
                                        </div>
                                        );
                                    }
                                })
                                }
                            </div>
                        );
                    }
                    })
                }
                </div>);
            }
            
        })
    }
    
    // On submit
    onSubmitUser(e){
        let self = this;
        e.preventDefault();
        self.setState({
            fireRequiredError: false,
            fireExistError: false
        })

        var qs = require("qs");

        const userToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token"),
            name        : self.state.user.name,
            lastname    : self.state.user.lastname,
            birthdate   : self.state.user.birthdate,
            position    : self.state.user.position,
            email       : self.state.user.email,
            phone       : self.state.user.phone,
            role        : self.state.user.role,
            business_id : self.props.business_id,
            modules     : self.state.min_selected_modules,
            action      : "advanced"

        });
        if(self.state.user_action=="new"){
            axios.post(uri_users, userToSent)
                    .then(response => { 
                        if ( response.data["status"] === "success" ){
                            self.props.setUserAddedNotification(true);
                            self.props.getUsers(self.props.business_id);
                            self.props.activeSection("setup","users","","");
                        }else{
                            if(response.data["message"] === "required"){
                                self.setState({
                                    fireRequiredError: true,
                                    fireExistError: false
                                })
                            }else{
                                self.setState({
                                    fireRequiredError: false,
                                    fireExistError: true
                                })
                            }
                        }
                    })
        }else{
            console.log(self.state.user);
            axios.post(uri_users+"/"+self.state.user._id, userToSent)
            .then(response => { 
                if ( response.data["status"] === "success" ){
                    self.props.setUserEditedNotification(true);
                    self.props.getUsers(self.props.business_id);
                    self.props.activeSection("setup","users","","");
                }else{
                    if(response.data["message"] === "required"){
                        self.setState({
                            fireRequiredError: true,
                            fireExistError: false
                        })
                    }else{
                        self.setState({
                            fireRequiredError: false,
                            fireExistError: true
                        })
                    }
                }
            })   

        }
    }

    render() {
        return (
            <section>
                <div className="head-content "> 
                    <div className="col-md-8 px-2">     
                        <h1>Configuration</h1>
                        <h2>USERS / ROLES</h2>
                    </div>
                    <div className="col-md-3 px-2">     
                    </div>
                </div>
                <div className={"suscription "}> 
                    <div className="box regular col-lg-5 col-md-6">
                        <h3 className="title-roles-h3">{this.state.title}</h3>
                        <div className="scrollable content-role-user">
                           <div className="title-role">
                              <h4>User data</h4>
                           </div> 
                           <Icon className={this.state.show_loading} type="loading" />
                           <span className={"error-login " + (this.state.fireExistError === true ? "" : "hide")}>
                                User already exists
                            </span>
                           <span className={"error-login " + (this.state.fireRequiredError === true ? "" : "hide")}>
                                All data is required
                            </span>
                           <form className={"inputs-roles "+ this.state.loaded}  onSubmit={this.onSubmitUser.bind(this)}>
                                <div className="content-input-user">
                                    <input className="input-role" name="name" placeholder="Name " value={(this.state.user.name==null)? "": this.state.user.name} required onChange={e => this.handleUserChange(e)} />
                                    <label>Name</label>
                                </div> 
                                <div className="content-input-user">
                                    <input className="input-role" name="lastname" placeholder="Last name " value={(this.state.user.lastname==null)? "": this.state.user.lastname} required onChange={e => this.handleUserChange(e)} />
                                    <label>Last name</label>
                                </div> 
                                <div className="content-input-user">
                                    <input type="date" className="input-role" name="birthdate" placeholder="Birth date " value={(this.state.user.birthdate==null)? "": this.state.user.birthdate} required onChange={e => this.handleUserChange(e)}  />
                                    <label>Birth date</label>
                                </div> 
                                <div className="content-input-user">
                                    <input className="input-role" name="position" placeholder="Position " value={(this.state.user.position==null)? "": this.state.user.position} required onChange={e => this.handleUserChange(e)}  />
                                    <label>Position</label>
                                </div> 
                                <div className="content-input-user">
                                    <input type="email" className="input-role" name="email" placeholder="E-mail " value={(this.state.user.email==null)? "": this.state.user.email} required onChange={e => this.handleUserChange(e)}  />
                                    <label>E-mail</label>
                                </div> 
                                <div className="content-input-user">
                                    <input className="input-role" name="phone" placeholder="Phone number " value={(this.state.user.phone==null)? "": this.state.user.phone} required onChange={e => this.handleUserChange(e)}  />
                                    <label>Phone number</label>
                                </div>   
                                <div className="content-select">
                                    <span>Rol</span>
                                    <select className="form-control top-form-select select-role " name="role" value={(this.state.user.role==null)? "": this.state.user.role} required onChange={e => this.handleUserChange(e)}>
                                        <option>Select a role</option>
                                        {this.renderRoles()} 
                                    </select>
                                </div> 
                                <div className="content-select">
                                    <span>Hotels</span>
  
                                    <select className="form-control top-form-select select-role " name="hotels" onChange={e => this.handleHotelChange(e)}>
                                        <option value="">Select hotel</option>
                                        {this.renderHotels()} 
                                    </select>
                                </div> 
                                <div className={"content-select " + this.state.hotel_selected_status}>
                                    <span> Modules / Panels </span>
                                    {this.renderModulesPanles()}
                                </div> 
                                <div className="content-select">
                                    <div className="buttons-user">
                                        <button onClick={this.props.activeSection.bind(this,"setup","users","","")}>Cancel</button>
                                        <button className="btn-primary" type="submit">Save</button>
                                    </div>
                             </div>      
                           </form>     
                         </div>       
                    </div> 
                    <div className={"box regular col-lg-5 col-md-7 " + this.state.hotel_checked_status}>
                        <h3>SUMMARY</h3>
                        <div className="scrollable content-role-user">
                            <div className="hotel-names">
                                <div className="title-role">
                                   <h4>Hotels - Modules</h4>
                                </div>
                                {this.renderSelectedModulesPanles()}
                            </div>
                         </div>       
                    </div> 
                </div>           
            </section>
        )
    }
}

export default AddUser


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/corporative/AddUser.js